import { render, staticRenderFns } from "./BiddingControls.vue?vue&type=template&id=4db3cfdb&scoped=true"
import script from "./BiddingControls.vue?vue&type=script&lang=js"
export * from "./BiddingControls.vue?vue&type=script&lang=js"
import style0 from "./BiddingControls.vue?vue&type=style&index=0&id=4db3cfdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3cfdb",
  null
  
)

export default component.exports